import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { getFeatureToggles, useConfig } from '../../../../state/configuration'
import { CheckoutDisabled } from './CheckoutDisabled'
import { CheckoutFailure } from './CheckoutFailure'
import { CheckoutPath } from './CheckoutPath'
import { CheckoutRoute } from './CheckoutRoute'

export const CheckoutRouter: FunctionComponent = () => {
  const { disableBind } = useConfig(getFeatureToggles)

  return disableBind ? (
    <CheckoutDisabled />
  ) : (
    <Routes>
      <Route index element={<CheckoutRoute />} />
      <Route path={CheckoutPath.CHECKOUT_CALLBACK} element={<CheckoutFailure />} />
      <Route path='*' element={<Navigate to='..' />} />
    </Routes>
  )
}
